import { useAppSelector } from "../../hooks/StoreHooks";

export const useEditMode = () =>
  useAppSelector((state) => state.tableManagement.editMode);

export const useCreateMode = () =>
  useAppSelector((state) => state.tableManagement.createMode);

export const useProcessingRequest = () =>
  useAppSelector((state) => state.tableManagement.processingRequest);

export const useResponseValue = () =>
  useAppSelector((state) => state.tableManagement.responseValue);

export const useResponseMessage = () =>
  useAppSelector((state) => state.tableManagement.responseMessage);